<!-- eslint-disable max-len -->
<template>
  <div v-if="loading" class="absolute inset-0 z-50 overflow-none ">
    <div class="m-auto spinner-bg flex h-full">
      <div class="m-auto rounded-full bg-white shadow-lg p-5 animate-spin">
        <img :src="logo" class="w-8 h-8" />
      </div>
    </div>
  </div>
</template>

<style scoped>
.spinner-bg {
  background-color: rgba(254, 254, 254, 0.8);
}
.animate-spin {
  animation: rotate 1s linear infinite, fadein 1s;
}
@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>

<script>
import logo from '@/assets/logo_sq.png';

export default {
  name: 'spinner',
  data() {
    return {
      logo,
    };
  },
  props: ['loading'],
};
</script>
